'use client';

import { useTheme } from 'next-themes';
import type { CSSProperties } from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

export default function Toaster({ ...props }: ToasterProps) {
  const { theme = 'light' } = useTheme();

  return (
    <Sonner
      className="toaster group"
      closeButton
      duration={3000}
      position="top-center"
      richColors
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as CSSProperties
      }
      theme={theme as ToasterProps['theme']}
      {...props}
    />
  );
}
